import { useSelector } from "react-redux";

const CampaignBuilders = () => {
  const OrgId = useSelector((state) => state.auth.org_id);
    return (
      <div className="">
          <iframe src={`https://iiplwork.retool.com/embedded/public/a0b24c1c-ba49-430e-a259-52d48d75a22c`}
          className="iframe-style"></iframe>
      </div>
  
    )
  };
  
  export default CampaignBuilders;
  